import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import {
  applyPolyfills,
  defineCustomElements,
} from "@liebherr/patternlib/loader";
import "@liebherr/patternlib/dist/patternlib/patternlib.css";
import { oidcConfig } from "../src/config/oidc";
import "./i18n";
import "./index.css";

const container = document.getElementById("hyzconfigurator");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// polyfills have to be included if IE is supported
applyPolyfills().then(() => {
  defineCustomElements(window);
});
